import {
  MICRO_LOAN_NOTIFICATIONS_ERROR,
  MICRO_LOAN_NOTIFICATIONS_START,
  MICRO_LOAN_NOTIFICATIONS_SUCCESS,
} from 'constants/action-types/loanRequests/microLoanNotifications';
import notification from 'helpers/notificationHelper';
import apiAction from 'helpers/apiAction';

export default queries => dispatch =>
  dispatch(
    apiAction({
      url: `/user/notifications/admin-requests`,
      method: 'GET',
      queries,
      API_REQUEST_START: MICRO_LOAN_NOTIFICATIONS_START,
      API_REQUEST_SUCCESS: MICRO_LOAN_NOTIFICATIONS_SUCCESS,
      API_REQUEST_FAILURE: MICRO_LOAN_NOTIFICATIONS_ERROR,
      callbackOnFailure: ({ message }) =>
        notification({ message, status: 'error' }),
      onEnd: () => false,
    }),
  );
